export default __webpack_public_path__ + "static/media/ic_paypal.d3de9248.svg";